<script lang="ts">
	import { LazyMarkdown } from '../../../../components/LazyMarkdown';
	import { Txt } from '../../../../components/Txt';
	import { extractNonNull } from '../../../../utils/extractNonNull/extractNonNull';
	import type { ArticleQuoteType } from '../../types';

	interface Props {
		item: ArticleQuoteType;
	}

	let { item }: Props = $props();

	let safeItem = $derived(extractNonNull(item, ['text'], {}));
</script>

{#if safeItem}
	<div class="border-l-2 border-gray-500 py-2 pl-4">
		<LazyMarkdown
			dataCy="blog-article-quote"
			source={item.quoteTokens ?? `"${safeItem.text}"`}
			class="[&>p>span]:text-[1.125rem] [&>p>span]:font-[500] [&>p>span]:italic [&>p>span]:leading-[1.5rem] [&>p]:mb-4 [&>p]:text-[1.125rem] [&>p]:font-[500] [&>p]:italic [&>p]:leading-[1.5rem]"
		/>

		{#if safeItem.attribution}
			<Txt variant="label3" class="text-gray-800" data-cy="blog-article-quote-attribution">
				- {safeItem.attribution}
			</Txt>
		{/if}
	</div>
{/if}
